enum UserRoleEnum {
  Admin = 'admin',
  Trusted = 'trusted',
  BusinessVet = 'vet',
  BusinessShelter = 'shelter',
}

export default UserRoleEnum;
